module.exports = __webpack_public_path__ + "img/bottomLogo.761932ca.png";